module.exports = __webpack_public_path__ + "img/gt-radial-tires.db091e76.png";